export default function btnColorChange() {
  const buttons = document.querySelectorAll(".btnnColorChange");

  const classes = ["primary", "yellow", "orange"];

  buttons.forEach((button) => {
    let hoverCount = 0;

    button.addEventListener("mouseenter", () => {
      button.classList.remove(...classes);
      button.classList.add(classes[hoverCount]);

      hoverCount = (hoverCount + 1) % classes.length;
    });

    button.addEventListener("mouseleave", () => {
      button.classList.remove(...classes);
    });
  });
}  
